import { ActionButtonProps, Form, ModBox } from '@jfs/ui-new'
import { Fragment, useRef, useState } from 'react'
import { ScrollView } from 'react-native'
import { DefaultFormContainer } from '../../../comps/DefaultFormContainer'
import { useLazyApiData, useStores } from '../../../data/store'
import { useWindowDimensions } from '../../../util/util'
import { beneficiaryTypesList, formEditBeneficiary } from '../SingleBeneficiary/form'
import BankPaymentData from './BankPaymentData'
import BeneficiaryData from './BeneficiaryData'
import Header from './Header'
import { styles } from './styles'

const BeneficiaryDetails = ({ closeDetailsView, data, mid }: any) => {
  const { updateBeneficiary } = useStores((store) => ({
    updateBeneficiary: store?.beneficiaryOnboarding.updateBeneficiary,
  }))
  const formActionButtonRef = useRef<ActionButtonProps>()

  const [updateBeneficiaryApi, updateBeneficiaryHandler] = useLazyApiData(updateBeneficiary)
  const [isEditMode, setEditMode] = useState(false)
  const [initValues, updateInitValues] = useState({
    name: data?.name ?? '',
    phone: data?.phone ?? '',
    email: data?.email ?? '',
    beneficiaryId: data?.id ?? '',
    beneficiaryType: data?.type ?? '',
    accountNumber: data?.accountNumber ?? '',
    ifsc: data?.ifsc ?? '',
    upiVpa: data?.vpa ?? '',
    cardNumber: data?.cardNumber ?? '',
  })

  const viewPortWidth = useWindowDimensions()
  const [isAddAddressPressed, onAddAddressPressed] = useState(false)
  const themes = styles(viewPortWidth)

  const onVerifySave = () => {
    formActionButtonRef.current?.defaultActionButtonOnSubmit()
    if (formActionButtonRef.current?.isValid) {
      const values = formActionButtonRef.current?.values
      updateBeneficiaryApi(values)
    }
  }

  const renderActionButtons = (props: ActionButtonProps) => {
    formActionButtonRef.current = props
    return <></>
  }
  const onBeneficiaryTypeItemSelected = (item: any) => {
    console.log('Beneficiary Details onBeneficiaryTypeItemSelected', item)
  }
  const onHandleAddAddressPressed = () => {
    onAddAddressPressed(true)
    setEditMode(true)
  }
  return (
    <ScrollView stickyHeaderIndices={[0]} style={themes.container}>
      <Header
        closeDetailsView={closeDetailsView}
        setEditMode={setEditMode}
        onVerifySave={onVerifySave}
        isValid={formActionButtonRef?.current?.isValid}
      />
      <Fragment>
        <BeneficiaryData data={data} isEditMode={isEditMode} onAddAddressPress={onHandleAddAddressPressed} />
        <BankPaymentData data={data} isEditMode={isEditMode} />
        <ModBox show={isEditMode} {...themes.detailsContainer}>
          <Form
            formData={formEditBeneficiary(
              true,
              data,
              isAddAddressPressed,
              onAddAddressPressed,
              false,
              onBeneficiaryTypeItemSelected,
              beneficiaryTypesList,
            )}
            actionButtons={(props) => renderActionButtons(props)}
            container={DefaultFormContainer}
            initialValues={initValues}
          />
        </ModBox>
      </Fragment>
    </ScrollView>
  )
}

export { BeneficiaryDetails }
